"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setThreshold = exports.isDateRangeGreaterThenThreshold = exports.isDateBefore = exports.isDateAfter = exports.dateFormatValid = exports.DATE_FORMAT_NATIVE = exports.DATE_FORMAT = void 0;
var _moment = _interopRequireDefault(require("moment"));
var DATE_FORMAT = exports.DATE_FORMAT = 'DD.MM.YYYY';
var DATE_FORMAT_NATIVE = exports.DATE_FORMAT_NATIVE = 'YYYY-MM-DD';
var THRESHOLD = 366;
var setThreshold = exports.setThreshold = function setThreshold(limit) {
  THRESHOLD = limit;
};
/**
 * strict date format check
 * @param {string} date - the date to check
 * @returns {boolean} - true/false if format is valid
 */
var dateFormatValid = exports.dateFormatValid = function dateFormatValid(date, props) {
  return !props || !props.isMobile && !props.isTablet ? (0, _moment.default)(date, DATE_FORMAT, true).isValid() : (0, _moment.default)(date, DATE_FORMAT_NATIVE, true).isValid();
};
/**
 * checks if a given date is before another reference date
 * @param {date} currentDate - date selected
 * @param {date} refDate - date reference to check against
 * @returns {boolean}
 */
var isDateBefore = exports.isDateBefore = function isDateBefore(currentDate, refDate) {
  return (0, _moment.default)(currentDate).isBefore(refDate, 'day');
};
/**
 * checks if a given date is after another reference date
 * @param {date} currentDate - date selected
 * @param {date} refDate - date reference to check against
 * @returns {boolean}
 */
var isDateAfter = exports.isDateAfter = function isDateAfter(currentDate, refDate) {
  return (0, _moment.default)(currentDate).isAfter(refDate, 'day');
};
/**
 * checks if range in days is greater then a given threshold
 * @param {date} fromDate - start date
 * @param {date} toDate - end date
 * @returns {boolean}
 */
var isDateRangeGreaterThenThreshold = exports.isDateRangeGreaterThenThreshold = function isDateRangeGreaterThenThreshold(fromDate, toDate) {
  return (0, _moment.default)(toDate).diff((0, _moment.default)(fromDate), 'days') >= THRESHOLD;
};